import { render, staticRenderFns } from "./ListButtons.vue?vue&type=template&id=0b4a5546"
import script from "./ListButtons.vue?vue&type=script&lang=js"
export * from "./ListButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports